export enum DataTypeJson {
    Decimal = 'decimal',
    String = 'string',
    Guid = 'guid', 
    DateTime = 'dateTime',
    Boolean = 'boolean',
    Object = 'object',
    Enum = 'enum'
}